module.exports = __webpack_public_path__ + "img/IEC30437.16d6ac30.png";